import React, { useEffect, useState } from "react";
import axios from "axios";
import "./Newarrival.css";
import HeaderTitle from "../HederTitle/HeaderTitle";
import { backend_url } from "../../App";
import { Link } from "react-router-dom";

const NewArrival = () => {
  const [collections, setCollections] = useState([]);

  useEffect(() => {
    fetchCollections();
  }, []);

  const fetchCollections = async () => {
    try {
      const response = await axios.get(`${backend_url}/api/newArrivals`);
      setCollections(response.data);
    } catch (error) {
      console.error("Error fetching collections:", error);
    }
  };

  return (
    <>
      <HeaderTitle Header="New Arrivals" />
      <div className="new-arrival-container mt-5">
        {collections.map((item) => (
          <Link to={`collections/${item.routeTo}`}>

            <div key={item._id} className="collection-card">
              <img crossOrigin="anonymous" 
                src={`${item.image}`}
                alt={item.collectionName}
                className="collection-image"
              />
              <div className="collection-title">{item.collectionName}</div>
            </div>
          </Link>

        ))}
      </div >
    </>
  );
};

export default NewArrival;